/* eslint-disable react/no-danger */
import React from 'react'
import { TEXTO_SUSPENSAO_PADRAO } from './constantsSuspensao'

const TextoSuspensao = () => {
  const htmlText = { '__html': TEXTO_SUSPENSAO_PADRAO }
  return (
    <div dangerouslySetInnerHTML={ htmlText } />
  )
}

export default TextoSuspensao
